import type { WidgetInstance } from '@trinity/chat';
import type { PageWidgetFromLibrary } from './PaletteContext.js';

type QuoteProps = {
  color?: string;
  insights?: unknown;
  quote?: unknown;
  media?: { clipUrl?: string; type?: 'audio' | 'video' | null; url?: string | null };
  speaker?: { name?: string; start?: number; end?: number };
  source?: {
    location?: 'transcript:call' | 'transcript:workspace' | null;
    projectId?: number;
    transcriptId?: number;
    callId?: number;
  };
};

/**
 * A picked project-library quote → the generic `quote` widget with the quote copied in, so it keeps
 * its media clip and Sources pane and survives the library quote being deleted. Same mapping as the
 * legacy-cell conversion in packages/backend-core/.../patient-journey/page-seed.ts.
 *
 * TODO: `media.url` is a signed link that expires, and it is stored in the page as-is. atrium re-signs it
 * on page reads (refreshPageQuoteMediaUrls); chat-api's segment and patient journey page GETs return the
 * stored config unchanged, so copied quote playback in apps/chat will break once the link expires. Either
 * add equivalent re-signing to chat-api's page reads, or sign at read time from `source.transcriptId`.
 */
export function libraryQuoteToQuoteWidget(widget: WidgetInstance): PageWidgetFromLibrary {
  const p = (widget.props ?? {}) as QuoteProps;
  return {
    type: 'quote',
    config: { title: '' },
    dataSource: {
      type: 'static',
      data: {
        type: 'quote',
        data: {
          color: p.color ?? '#000000',
          insights: p.insights ?? { type: 'doc', content: [] },
          quote: p.quote ?? { type: 'doc', content: [] },
          media: { clipUrl: p.media?.clipUrl, type: p.media?.type ?? null, url: p.media?.url ?? null },
          speaker: { name: p.speaker?.name ?? '', start: p.speaker?.start ?? 0, end: p.speaker?.end ?? 0 },
          source: {
            location: p.source?.location ?? null,
            projectId: p.source?.projectId ?? 0,
            transcriptId: p.source?.transcriptId ?? 0,
            callId: p.source?.callId,
          },
        },
      },
    },
  };
}
